import React, { useState, useRef } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableRow,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Card,
    CardContent,
    Grid,
    Divider,
    Collapse,
    Typography,
    TableHead,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import { Add, Edit, Remove, ExpandMore, ExpandLess } from '@material-ui/icons';
import { Parser } from 'expr-eval';
import { normalize, zeroPad } from '../../Helpers/utilityFunctions';
import { ExcelIcon } from "../../UIComponents/icons";
import PayrollCostCenterAllocationsExcelExport from "./PayrollCostCenterAllocationsExcelExport";
import { green, red } from "@material-ui/core/colors";
import moment from "moment";
import ReportHeader from "./reportHeader";
import CsvDownloader from 'react-csv-downloader';
import { CsvIcon } from "../../UIComponents/icons";
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import AllocationSheet from './AllocationSheet';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

const defaultCostCenterAllocationItems = [
    {
        name: "Staff Salary",
        key: "salary",
        category: "Expense",
        expression: "basicSalary",
        dimentions: [
            {
                field: "function",
                value: "Support"
            }, 
            {
                field: "function",
                value: "Technical"
            }
        ]
    },
    {
        name: "Termination Benefit",
        key: "termination",
        category: "Expense",
        expression: "terminationbenefit",
        dimentions: [
            {
                field: "function",
                value: "Support"
            },
            {
                field: "function",
                value: "Technical"
            }
        ]
    },
    {
        name: "Fringe Benefit",
        key: "fringe",
        category: "Expense",
        expression: "transportallowance+companyPension+changeallowance",
            dimentions: [
            {
                field: "function",
                value: "Support"
            },
            {   
                field: "function",
                value: "Technical"
            }
        ]
    },
    {
        name: " Health Insurance",
        key: "healthInsurance",
        category: "Expense",
         expression: "healthinsurance",
         dimentions: [
            {
                field: "function",
                value: "Support"
            },
             {   
                field: "function",
                value: "Technical"
            }
         ]
     },
     {
        name:"Salary Payable",
        key:"salaryPayable",
        category:"Payable",
        expression:"cash",
        dimentions:[]
     },
     {
        name:"Income Tax Payable",
        key:"incomeTaxPayable",
        category:"Payable",
        expression:"incomeTax",
        dimentions:[]
     },
     {
        name:"Termination Benefit Payable",
        key:"terminationBenefitPayable",
        category:"Payable",
        expression:"terminationbenefit",
        dimentions:[]
     },
     {
        name:"Pension Payable",
        key:"pensionPayable",
        category:"Payable",
        expression:"companyPension+empPension",
        dimentions:[]
     },
     {
        name:"Health Insurance Payable",
        key:"healthInsurancePayable",
        category:"Payable",
        expression:"healthinsurance",
        dimentions:[]
     }
]

const AddOrEditAllocation = ({ open, handleClose, editingItem, onSubmit }) => {
    const [formData, setFormData] = useState({
        name: '',
        expression: '',
        dimentions: []
    });

    React.useEffect(() => {
        if (editingItem) {
            setFormData(editingItem);
        } else {
            setFormData({
                name: '',
                expression: '',
                dimentions: []
            });
        }
    }, [editingItem]);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleDimensionChange = (index, field, value) => {
        const newDimensions = [...formData.dimentions];
        newDimensions[index] = {
            ...newDimensions[index],
            [field]: value
        };
        setFormData({
            ...formData,
            dimentions: newDimensions
        });
    };

    const addDimension = () => {
        setFormData({
            ...formData,
            dimentions: [...formData.dimentions, {
                field: '',
                value: ''
            }]
        });
    };

    const removeDimension = (index) => {
        const newDimensions = formData.dimentions.filter((_, i) => i !== index);
        setFormData({
            ...formData,
            dimentions: newDimensions
        });
    };

    const handleSubmit = () => {
        onSubmit(formData);
        handleClose();
    };

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                {editingItem ? "Edit Allocation" : "Add Allocation"}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                           
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            margin="normal"
                        />
                        <TextField
                          
                            label="Key"
                            name="key"
                            value={formData.key}
                            onChange={handleInputChange}
                            margin="normal"
                        />  
                    <FormControl width={200} margin="normal">
                        <InputLabel>Category</InputLabel>
                        <Select
                            name="category"
                            value={formData.category}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="Expense">Expense</MenuItem>
                            <MenuItem value="Payable">Payable</MenuItem>
                        </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                    <TextField
                            fullWidth
                            label="Expression"
                            name="expression"
                            value={formData.expression}
                            onChange={handleInputChange}
                            margin="normal"
                        />
                    </Grid>
              
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<Add />}
                            onClick={addDimension}
                            style={{ marginTop: 16 }}
                        >
                            Add Dimension
                        </Button>
                    </Grid>

                    {formData.dimentions.map((dimension, index) => (
                        <Grid item xs={12} key={index}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={5}>
                                    <TextField
                                        fullWidth
                                        label="Field"
                                        value={dimension.field}
                                        onChange={(e) => handleDimensionChange(index, 'field', e.target.value)}
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Value"
                                        value={dimension.value}
                                        onChange={(e) => handleDimensionChange(index, 'value', e.target.value)}
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <IconButton size="small" onClick={() => removeDimension(index)}>
                                        <Remove />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    {editingItem ? 'Update' : 'Add'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const CostCenterAllocationItemsView = ({ costCenterAllocationItems, setCostCenterAllocationItems }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    const handleEdit = (item) => {
        setEditingItem(item);
        setIsModalOpen(true);
    };

    const handleDelete = (record) => {
        setCostCenterAllocationItems(prevItems => 
            prevItems.filter(item => item.name !== record.name)
        );
    };

    const handleAdd = () => {
        setEditingItem(null);
        setIsModalOpen(true);
    };

    const handleSubmit = (formData) => {
        if (editingItem) {
            setCostCenterAllocationItems(prevItems =>
                prevItems.map(item =>
                    item.name === editingItem.name ? formData : item
                )
            );
        } else {
            setCostCenterAllocationItems(prevItems => [...prevItems, formData]);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={handleAdd}
                    style={{ marginBottom: 16 }}
                >
                    Add Allocation
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Table size="small">
                    <TableBody>
                        <TableRow>
                            <TableCell>Category</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Expression</TableCell>
                            <TableCell>Dimensions</TableCell>

                            <TableCell>Actions</TableCell>
                        </TableRow>
                        {costCenterAllocationItems.map((item) => (

                            <TableRow key={item.name}>
                                <TableCell>{item.category}</TableCell>
                                <TableCell>{item.name}</TableCell>
                                <TableCell>{item.expression}</TableCell>
                                <TableCell>
                                    {item.dimentions.map((dimension, index) => (
                                        <div key={index}>
                                            {dimension.field}: {dimension.value}
                                        </div>
                                    ))}
                                </TableCell>
                                <TableCell>
                                    <IconButton size="small" onClick={() => handleEdit(item)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleDelete(item)}>
                                        <Remove />
                                    </IconButton>
                                </TableCell> 
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>

            <AddOrEditAllocation 
                open={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                editingItem={editingItem}
                onSubmit={handleSubmit}
            />
        </Grid>
    );
};

const AllocationResultsTable = ({ results, columnTotals, grandTotal }) => {
    // State for tracking which site allocations are expanded
    const [expandedSites, setExpandedSites] = useState(new Set());

    const toggleSiteExpansion = (costCenterId, siteCode) => {
        const key = `${costCenterId}-${siteCode}`;
        setExpandedSites(prev => {
            const newSet = new Set(prev);
            if (newSet.has(key)) {
                newSet.delete(key);
            } else {
                newSet.add(key);
            }
            return newSet;
        });
    };

    if (!results || results.length === 0) return null;

    // Get all items/dimensions for header from first site allocation
    const firstSiteAlloc = results.length > 0 && results[0].siteAllocations && results[0].siteAllocations.length > 0 ? results[0].siteAllocations[0] : undefined;
    const items = firstSiteAlloc ? firstSiteAlloc.items : [];

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell rowSpan={2}>Cost Center</TableCell>
                    <TableCell rowSpan={2}>Site</TableCell>
                    {items.map(item => (
                        <TableCell colSpan={item.dimensions.length} key={item.name} align="center">
                            {item.name}
                        </TableCell>
                    ))}
                    <TableCell rowSpan={2}>Total</TableCell>
                </TableRow>
                <TableRow>
                    {items.map(item => (
                        item.dimensions.map(dim => (
                            <TableCell key={`${item.name}-${dim.name}`}>{dim.name}</TableCell>
                        ))
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {results.filter(result => result.total !== 0).map((result) => {
                    // Calculate per-dimension totals for this cost center
                    let dimensionTotals = [];
                    if (items.length > 0) {
                        dimensionTotals = items.flatMap(item =>
                            item.dimensions.map((dim, dimIdx) =>
                                result.siteAllocations
                                    .filter(siteAlloc => siteAlloc.total !== 0)
                                    .reduce((sum, siteAlloc) => {
                                        const foundItem = siteAlloc.items.find(i => i.name === item.name);
                                        if (foundItem) {
                                            return sum + ((foundItem.dimensions[dimIdx]&&foundItem.dimensions[dimIdx].value )|| 0);
                                        }
                                        return sum;
                                    }, 0)
                            )
                        );
                    }
                    return (
                        <React.Fragment key={result.costCenter.id}>
                            {/* Cost center total row */}
                            <TableRow style={{ background: '#f0f0f0', fontWeight: 'bold' }}>
                                <TableCell>{result.costCenter.code}</TableCell>
                                <TableCell colSpan={1}></TableCell>
                                {dimensionTotals.map((dimTotal, idx) => (
                                    <TableCell key={idx}>{dimTotal !== 0 ? dimTotal.toFixed(2) : ''}</TableCell>
                                ))}
                                <TableCell>{result.total.toFixed(2)}</TableCell>
                            </TableRow>
                            {/* Per-site rows */}
                            {result.siteAllocations.filter(siteAlloc => siteAlloc.total !== 0).map(siteAlloc => {
                                const siteKey = `${result.costCenter.id}-${siteAlloc.site}`;
                                const isExpanded = expandedSites.has(siteKey);
                                
                                return (
                                    <React.Fragment key={siteAlloc.site}>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => toggleSiteExpansion(result.costCenter.id, siteAlloc.site)}
                                                        style={{ marginRight: 8 }}
                                                    >
                                                        {isExpanded ? <ExpandLess /> : <ExpandMore />}
                                                    </IconButton>
                                                    {siteAlloc.site}
                                                </div>
                                            </TableCell>
                                            {siteAlloc.items.map(item => (
                                                item.dimensions.map(dim => (
                                                    <TableCell key={`${item.name}-${dim.name}`}>
                                                        {dim.value.toFixed(2)}<br />
                                                        <span style={{fontStyle:'italic',color:'#888'}}>
                                                            {dim.account ? dim.account.code : '-'}
                                                        </span>
                                                    </TableCell>
                                                ))
                                            ))}
                                            <TableCell>{siteAlloc.total.toFixed(2)}</TableCell>
                                        </TableRow>
                                        {/* Employee details rows */}
                                        {isExpanded && (() => {
                                            const employeeMap = new Map();
                                            siteAlloc.items.forEach(item => {
                                                item.dimensions.forEach(dim => {
                                                    if (dim.employees) {
                                                        dim.employees.forEach(emp => {
                                                            if (!employeeMap.has(emp.employeeId)) {
                                                                employeeMap.set(emp.employeeId, {
                                                                    orgID: emp.orgID,
                                                                    fullName: emp.fullName,
                                                                    allocationPercent: emp.allocationPercent,
                                                                    dimensions: {}
                                                                });
                                                            }
                                                            employeeMap.get(emp.employeeId).dimensions[`${item.name}-${dim.name}`] = emp.value;
                                                        });
                                                    }
                                                });
                                            });
                                            
                                            const employees = Array.from(employeeMap.values())
                                                .filter(emp => {
                                                    // Only show employees with non-zero contributions
                                                    const total = Object.values(emp.dimensions).reduce((sum, val) => sum + (val || 0), 0);
                                                    return total > 0;
                                                });

                                            return employees.map(emp => (
                                                <TableRow key={emp.orgID} style={{ backgroundColor: '#f9f9f9' }}>
                                                    <TableCell />
                                                    <TableCell style={{ paddingLeft: 32, fontSize: '0.8rem', color: '#666' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                 
                                                            <div>
                                                                <div style={{ fontWeight: 'bold' }}>{emp.orgID}</div>
                                                                <div >{emp.fullName}</div>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    {items.map(item => (
                                                        item.dimensions.map(dim => {
                                                            const key = `${item.name}-${dim.name}`;
                                                            const value = emp.dimensions[key] || 0;
                                                            return (
                                                                <TableCell key={key} style={{ fontSize: '0.8rem', color: '#666' }}>
                                                                    {value > 0 ? value.toFixed(2) : ''}
                                                                </TableCell>
                                                            );
                                                        })
                                                    ))}
                                                    <TableCell style={{ fontSize: '0.8rem', color: '#666', fontWeight: 'bold' }}>
                                                        <div>
                                                            {Object.values(emp.dimensions).reduce((sum, val) => sum + (val || 0), 0).toFixed(2)}
                                                            <div style={{ fontSize: '0.7rem', opacity: 0.7, marginTop: 2 }}>
                                                                ({emp.allocationPercent*100}%)
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ));
                                        })()}
                                    </React.Fragment>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
                <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell />
                    {columnTotals.map((total, idx) => (
                        <TableCell key={idx}>{total.toFixed(2)}</TableCell>
                    ))}
                    <TableCell>{grandTotal.toFixed(2)}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

// Utility functions for calculations
const safeEvaluate = (expr, context) => {
    const safeContext = new Proxy(context, {
        get(target, prop) {
            return target[prop] !== undefined ? target[prop] : 0;
        }
    });
    return expr.evaluate(safeContext);
};

const calculateValue = (payroll, parsedExpr, dimension, allocationPercent) => {
    if (payroll[dimension.field] !== dimension.value) return 0;

    if (!parsedExpr) return 0;

    try {
        const value = safeEvaluate(parsedExpr, payroll);
        return value * allocationPercent;
    } catch (error) {
        console.error('Error evaluating expression:', error, payroll);
        return 0;
    }
};

const findMatchingRegionAccount = (accounts, {key, regionShortName }) => {
  
    const normalizedKey = normalize(key);
    const normalizedShortName = normalize(regionShortName);
    
    return accounts.find(account => 
         account.tags && 
        account.tags.some(tag => normalize(tag) === normalizedShortName) &&
        account.tags.some(tag => normalize(tag) === normalizedKey)
    );
};


const AllocationCSVExport = ({ allocationResults, payrollDate, region, department, payablesAllocations, sites }) => {
    if (!allocationResults) return null;
    const getCSVData = () => {
        const lastDayOfMonth = moment(payrollDate).endOf('month').format('MM/DD/YYYY');
        const reference = `JL${moment(payrollDate).format('YYMM')}`;
        // Expense rows
        const expenseRows = allocationResults.results
            .filter(result => result.total !== 0)
            .flatMap(result =>
                result.siteAllocations
                    .filter(siteAlloc => siteAlloc.total !== 0)
                    .flatMap(siteAlloc =>
                        siteAlloc.items.flatMap(item =>
                            item.dimensions
                                .filter(dim => dim.value !== 0)
                                .map(dim => ({
                                    AccountCostCentre: result.costCenter.code,
                                    AccountDepartment: department || 'M24',
                                    AccountNumber: dim.account ? dim.account.code : '',
                                    TransactionType: '1',
                                    TransactionDate: lastDayOfMonth,
                                    GoodsAmount: dim.value.toFixed(2),
                                    Reference: reference+zeroPad(siteAlloc.regionCode,3),
                                    Narrative: `${siteAlloc.site ? siteAlloc.site + '-' : ''}${item.name} - ${dim.name} - ${moment(payrollDate).format("[M]MM-YYYY")}`,
                                    UserNumber: '4',
                                    Source: '3',
                                    PostedDate: lastDayOfMonth
                                }))
                        )
                    )
            );
        // Payables rows (negative values, no cost center) - Region-based
        let payablesRows = [];
        if (payablesAllocations && sites) {
            console.log({payablesAllocations})
            payablesAllocations.forEach(item => {
                // Group site allocations by region
                const regionAllocations = {};
                item.siteAllocations.forEach(siteAlloc => {
                    const siteObj = sites.find(s => s.code === siteAlloc.site);
                    const region = siteObj && siteObj.region;
                    if (!region) return;
                    const regionId = region.id;
                    if (!regionAllocations[regionId]) {
                        regionAllocations[regionId] = {
                            regionCode: region.code,
                            shortName: region.shortName,
                            dimensions: {},
                            value: 0,
                            account: null
                        };
                    }
                    if (siteAlloc.dimensions && siteAlloc.dimensions.length > 0) {
                        siteAlloc.dimensions.forEach(dim => {
                            if (!regionAllocations[regionId].dimensions[dim.name]) {
                                regionAllocations[regionId].dimensions[dim.name] = {
                                    value: 0,
                                    account: dim.account
                                };
                            }
                            regionAllocations[regionId].dimensions[dim.name].value += dim.value;
                        });
                    } else if (siteAlloc.value && siteAlloc.value !== 0) {
                        regionAllocations[regionId].value += siteAlloc.value;
                        regionAllocations[regionId].account = siteAlloc.account;
                    }
                });

                // Create rows per region
                Object.values(regionAllocations).forEach(regAlloc => {
                    console.log({regAlloc})
                    if (Object.keys(regAlloc.dimensions).length > 0) {
                        Object.entries(regAlloc.dimensions).forEach(([dimName, dimData]) => {
                            if (dimData.value !== 0) {
                                payablesRows.push({
                                    AccountCostCentre: '',
                                    AccountDepartment: department || 'M24',
                                    AccountNumber: dimData.account ? dimData.account.code : '',
                                    TransactionType: '1',
                                    TransactionDate: lastDayOfMonth,
                                    GoodsAmount: (-Math.abs(dimData.value)).toFixed(2),
                                    Reference: reference + zeroPad(regAlloc.regionCode, 3),
                                    Narrative: `${regAlloc.shortName} -  ${item.name} - ${dimName} - ${moment(payrollDate).format("[M]MM-YYYY")}`,
                                    UserNumber: '4',
                                    Source: '3',
                                    PostedDate: lastDayOfMonth
                                });
                            }
                        });
                    } else if (regAlloc.value !== 0) {
                        payablesRows.push({
                            AccountCostCentre: '',
                            AccountDepartment: department || 'M24',
                            AccountNumber: regAlloc.account ? regAlloc.account.code : '',
                            TransactionType: '1',
                            TransactionDate: lastDayOfMonth,
                            GoodsAmount: (-Math.abs(regAlloc.value)).toFixed(2),
                            Reference: reference + zeroPad(regAlloc.regionCode, 3),
                            Narrative: `${regAlloc.shortName} - ${item.name} - ${moment(payrollDate).format("[M]MM-YYYY")}`,
                            UserNumber: '4',
                            Source: '3',
                            PostedDate: lastDayOfMonth
                        });
                    }
                });
            });
        }
        return [...expenseRows, ...payablesRows];
    };

    return (
        <CsvDownloader
            filename={`Payday_sage_import_${moment(payrollDate).format("MMM-YYYY")}`}
            extension=".csv"
            separator=","
            bom={false}
            columns={[
                "AccountCostCentre",
                "AccountDepartment",
                "AccountNumber",
                "TransactionType",
                "TransactionDate",
                "GoodsAmount",
                "Reference",
                "Narrative",
                "UserNumber",
                "Source",
                "PostedDate"
            ]}
            datas={getCSVData}
        >
            <Button
                variant="outlined"
                color="primary"
                startIcon={<CsvIcon style={{ color: green[500] }}/>} 
            >
                Download SAGE Import
            </Button>
        </CsvDownloader>
    );
};

// Payables Allocation Table (Horizontal Layout)
const PayablesAllocationTable = ({ payablesAllocations, sites }) => {
    const [expandedRegions, setExpandedRegions] = useState(new Set());

    const toggleRegionExpansion = (regionId) => {
        setExpandedRegions(prev => {
            const newSet = new Set(prev);
            if (newSet.has(regionId)) {
                newSet.delete(regionId);
            } else {
                newSet.add(regionId);
            }
            return newSet;
        });
    };

    if (!payablesAllocations || payablesAllocations.length === 0) return null;
    // Build columns: for each item, for each dimension (or just the item if no dimension)
    let columns = [];
    payablesAllocations.forEach(item => {
        if (item.siteAllocations && item.siteAllocations.length > 0 && item.siteAllocations[0].dimensions) {
            // Has dimensions
            item.siteAllocations[0].dimensions.forEach(dim => {
                columns.push({
                    itemName: item.name,
                    dimension: dim.name
                });
            });
        } else {
            // No dimensions
            columns.push({
                itemName: item.name,
                dimension: null
            });
        }
    });
    // Remove duplicates (in case of inconsistent dimensions)
    columns = columns.filter((col, idx, arr) =>
        arr.findIndex(c => c.itemName === col.itemName && c.dimension === col.dimension) === idx
    );

    // Group sites by region
    const regionsMap = new Map();
    (sites || []).forEach(siteObj => {
        const regionName = siteObj.region ? (siteObj.region.name || 'Unknown Region') : 'No Region';
        const regionId = siteObj.region ? siteObj.region.id : 'no-region';
        
        if (!regionsMap.has(regionId)) {
            regionsMap.set(regionId, {
                id: regionId,
                name: regionName,
                sites: []
            });
        }
        regionsMap.get(regionId).sites.push(siteObj);
    });

    // Process data per region
    const regionRows = Array.from(regionsMap.values()).map(region => {
        // Calculate rows for sites in this region
        const siteRows = region.sites.map(siteObj => {
            const siteCode = siteObj.code;
            const row = { site: siteCode, siteName: siteObj.name, values: {}, total: 0 };
            columns.forEach(col => {
                // Find the item
                const item = payablesAllocations.find(i => i.name === col.itemName);
                if (!item) return;
                // Find the site allocation
                const siteAlloc = item.siteAllocations.find(sa => sa.site === siteCode);
                if (!siteAlloc) return;
                if (col.dimension) {
                    // Find dimension
                    const dim = siteAlloc.dimensions && siteAlloc.dimensions.find(d => d.name === col.dimension);
                    if (dim) {
                        row.values[`${col.itemName}__${col.dimension}`] = { value: dim.value, account: dim.account };
                        row.total += dim.value;
                    } else {
                        row.values[`${col.itemName}__${col.dimension}`] = { value: 0, account: null };
                    }
                } else {
                    // No dimension
                    row.values[`${col.itemName}__`] = { value: siteAlloc.value || 0, account: siteAlloc.account };
                    row.total += siteAlloc.value || 0;
                }
            });
            return row;
        });

        // Calculate region totals
        const regionValues = {};
        let regionTotal = 0;
        columns.forEach(col => {
            const key = `${col.itemName}__${col.dimension || ''}`;
            const sum = siteRows.reduce((acc, row) => acc + ((row.values[key] && row.values[key].value) || 0), 0);
            regionValues[key] = { value: sum };
        });
        regionTotal = siteRows.reduce((acc, row) => acc + row.total, 0);

        return {
            ...region,
            siteRows,
            values: regionValues,
            total: regionTotal
        };
    });

    // Column totals (Grand totals across all regions)
    const columnTotals = columns.map(col =>
        regionRows.reduce((sum, region) => sum + ((region.values[`${col.itemName}__${col.dimension || ''}`] && region.values[`${col.itemName}__${col.dimension || ''}`].value) || 0), 0)
    );
    const grandTotal = regionRows.reduce((sum, region) => sum + region.total, 0);

    return (
        <Table size="small" style={{ marginTop: 32 }}>
            <TableHead>
                <TableRow>
                    <TableCell rowSpan={2}>Region / Site</TableCell>
                    {columns.map(col => (
                        <TableCell colSpan={1} key={col.itemName + (col.dimension ? '-' + col.dimension : '')} align="center">
                            {col.itemName}
                        </TableCell>
                    ))}
                    <TableCell rowSpan={2}>Total</TableCell>
                </TableRow>
                <TableRow>
                    {columns.map(col => (
                        <TableCell key={col.itemName + '-dim-' + (col.dimension || '')}>{col.dimension || ''}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {regionRows.filter(region => region.total !== 0).map(region => {
                    const isExpanded = expandedRegions.has(region.id);
                    return (
                        <React.Fragment key={region.id}>
                            {/* Region Row */}
                            <TableRow style={{ background: '#f0f0f0', fontWeight: 'bold' }}>
                                <TableCell>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <IconButton
                                            size="small"
                                            onClick={() => toggleRegionExpansion(region.id)}
                                            style={{ marginRight: 8 }}
                                        >
                                            {isExpanded ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                        {region.name}
                                    </div>
                                </TableCell>
                                {columns.map(col => {
                                    const cell = region.values[`${col.itemName}__${col.dimension || ''}`];
                                    return (
                                        <TableCell key={col.itemName + '-' + (col.dimension || '')}>
                                            {cell && cell.value !== 0 ? cell.value.toFixed(2) : ''}
                                        </TableCell>
                                    );
                                })}
                                <TableCell>{region.total !== 0 ? region.total.toFixed(2) : ''}</TableCell>
                            </TableRow>
                            
                            {/* Site Rows (if expanded) */}
                            {isExpanded && region.siteRows.filter(row => row.total !== 0).map(row => (
                                <TableRow key={row.site} style={{ backgroundColor: '#f9f9f9' }}>
                                    <TableCell style={{ paddingLeft: 48 }}>
                                        {row.site}
                                    </TableCell>
                                    {columns.map(col => {
                                        const cell = row.values[`${col.itemName}__${col.dimension || ''}`];
                                        return (
                                            <TableCell key={col.itemName + '-' + (col.dimension || '')}>
                                                {cell && cell.value !== 0 ? cell.value.toFixed(2) : ''}
                                                {cell && cell.value !== 0 && (
                                                    <><br /><span style={{fontStyle:'italic',color:'#888'}}>{cell.account ? (cell.account.code || '-') : '-'}</span></>
                                                )}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>{row.total !== 0 ? row.total.toFixed(2) : ''}</TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    );
                })}
                <TableRow>
                    <TableCell>Total</TableCell>
                    {columnTotals.map((total, idx) => (
                        <TableCell key={idx}>{total !== 0 ? total.toFixed(2) : ''}</TableCell>
                    ))}
                    <TableCell>{grandTotal !== 0 ? grandTotal.toFixed(2) : ''}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

const PayrollCostCenterAllocations = ({ logo, company, filteredPayrolls, payrollRun, costCenters, accounts, payrollDate, region, department, site, sites }) => {
    const [costCenterAllocationItems, setCostCenterAllocationItems] = useState(defaultCostCenterAllocationItems);
    const [expanded, setExpanded] = useState(false);
    const [allocationSheetExpanded, setAllocationSheetExpanded] = useState(false);
    const [allocationResults, setAllocationResults] = useState(null);
    const [payablesAllocations, setPayablesAllocations] = useState([]);
    const [payablesGrandTotal, setPayablesGrandTotal] = useState(0);
    const componentRef = useRef();

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleAllocationSheetExpandClick = () => {
        setAllocationSheetExpanded(!allocationSheetExpanded);
    };

    const handleAllocationUpdate = (employeeId, allocations) => {
        // Update the payroll run with new allocations
        // console.log(employeeId, allocations)
        if (payrollRun) {
            if (!payrollRun.payrollRunCostCenterAllocations) {
                payrollRun.payrollRunCostCenterAllocations = {};
            }
            payrollRun.payrollRunCostCenterAllocations[employeeId] = allocations;
            console.log(payrollRun.payrollRunCostCenterAllocations)
        }
    };

    const handleAllocate = () => {
        // Check if payrollRunCostCenterAllocations is not empty before proceeding
        if (!payrollRun.payrollRunCostCenterAllocations || Object.keys(payrollRun.payrollRunCostCenterAllocations).length === 0) {
            alert('No cost center allocations found. Please set up employee allocations in the Allocation Sheet before proceeding.');
            return;
        }

        // Pre-parse expressions for performance
        const expenseItems = costCenterAllocationItems.filter(c => c.category === "Expense");
        const parsedExpressions = {};
        expenseItems.forEach(item => {
            try {
                parsedExpressions[item.expression] = new Parser().parse(item.expression);
            } catch (e) {
                console.error('Error parsing expression:', item.expression, e);
                parsedExpressions[item.expression] = null;
            }
        });

        // Separate adjusted and non-adjusted payrolls
        const adjustedPayrolls = filteredPayrolls.filter(p =>
            p.employeeAdjustments &&
            Array.isArray(p.employeeAdjustments) &&
            p.employeeAdjustments.some(a =>
                a.adjustmentType === 'Site' &&
                moment(a.effectiveDate).isAfter(moment(payrollRun.payrollStartDate))
            )
        );
        const nonAdjustedPayrolls = filteredPayrolls.filter(p => !adjustedPayrolls.includes(p));

        // Get unique sites from filteredPayrolls
        const uniqueSites = [...new Set([...nonAdjustedPayrolls.map(p => p.siteName), ...adjustedPayrolls.map(p => p.siteName)])];
        const relevantSites = sites.filter(site => uniqueSites.includes(site.name));

        // Get unique cost centers from payroll allocations
        const uniqueCostCenters = [...new Set(Object.values(payrollRun.payrollRunCostCenterAllocations).flat().map(a => a.costCenterCode))];
        const relevantCostCenters = costCenters.filter(costCenter => uniqueCostCenters.some(code => normalize(code) === normalize(costCenter.code)));

        // console.log({ca:payrollRun.payrollRunCostCenterAllocations, nonAdjustedPayrolls, uniqueSites, relevantSites, uniqueCostCenters, relevantCostCenters})
        // Group non-adjusted payrolls by site
        const sitePayrollsMap = {};
        nonAdjustedPayrolls.forEach(p => {
            const siteName = normalize(p.siteName);
            if (!sitePayrollsMap[siteName]) sitePayrollsMap[siteName] = [];
            sitePayrollsMap[siteName].push(p);
        });

        // Per-site allocation logic with site movement adjustment
        const results = relevantCostCenters.map(costCenter => {
            // For each cost center, build a list of site allocations
            const siteAllocations = relevantSites.map(siteObj => {
                const siteCode = siteObj.code;
                const siteName = normalize(siteObj.name);
                const regionCode = siteObj.region ? siteObj.region.code : 0;
                const regionShortName = siteObj.region ? siteObj.region.shortName || siteObj.region.name : siteCode;
                return {
                    site: siteCode,
                    regionCode: regionCode,
                    items: expenseItems.map(item => ({
                        name: item.name,
                        dimensions: item.dimentions.map(dim => {
                            // Find account using tags: costCenter, key, dimension, and site code
                            const account = accounts.find(account =>
                                account.costCenterId === costCenter.id &&
                                account.tags &&
                                account.tags.some(tag => normalize(tag) === normalize(dim.value)) &&
                                account.tags.some(tag => normalize(tag) === normalize(item.key)) &&
                                account.tags.some(tag => normalize(tag) === normalize(regionShortName))
                            );
                            // Payrolls for this site, including site movement adjustments
                            let value = 0;
                            let employees = [];
                            const parsedExpr = parsedExpressions[item.expression];

                            // Handle non-adjusted payrolls efficiently
                            const sitePayrolls = sitePayrollsMap[siteName] || [];
                            sitePayrolls.forEach(p => {
                                const employeeAllocations = payrollRun.payrollRunCostCenterAllocations[p.employeeId];
                                const costCenterAllocation = employeeAllocations ? employeeAllocations.find(
                                    a => normalize(a.costCenterCode) === normalize(costCenter.code)
                                ) : null;
                                const allocationPercent = costCenterAllocation ? costCenterAllocation.allocationPercentage : 0;
                                const siteValue = calculateValue(p, parsedExpr, dim, allocationPercent);
                                if (siteValue > 0) {
                                    employees.push({
                                        employeeId: p.employeeId,
                                        fullName: p.fullName,
                                        orgID: p.orgID,
                                        value: siteValue,
                                        allocationPercent: allocationPercent
                                    });
                                }
                                value += siteValue;
                            });

                            // Handle adjusted payrolls
                            adjustedPayrolls.forEach(p => {
                                let siteValue = 0;
                                const adjustments = p.employeeAdjustments.filter(a =>
                                    a.effectiveDate &&
                                    moment(a.effectiveDate).isAfter(moment(payrollRun.payrollStartDate)) &&
                                    a.adjustmentType === 'Site'
                                );
                                if (adjustments.length > 0) {
                                    adjustments.forEach(a => {
                                        const oldSite = sites.find(s => s.id === a.oldValue);
                                        const oldSiteName = oldSite ? normalize(oldSite.name) : null;
                                        const totalDaysInPayPeriod = moment(payrollRun.payrollEndDate).diff(moment(payrollRun.payrollStartDate), 'days') + 1;
                                        const daysBeforeNewSite = Math.min(
                                            moment(a.effectiveDate).diff(moment(payrollRun.payrollStartDate), 'days'),
                                            totalDaysInPayPeriod
                                        );
                                        const daysAfterNewSite = Math.max(0, totalDaysInPayPeriod - daysBeforeNewSite);

                                        const employeeAllocations = payrollRun.payrollRunCostCenterAllocations[p.employeeId];
                                        const costCenterAllocation = employeeAllocations ? employeeAllocations.find(
                                            a => normalize(a.costCenterCode) === normalize(costCenter.code)
                                        ) : null;
                                        const allocationPercent = costCenterAllocation ? costCenterAllocation.allocationPercentage : 0;

                                        // If this site is the old site
                                        if (oldSiteName === siteName) {
                                            const adjustedPayroll = { ...p, site: oldSite.code, siteName: oldSite.name, payrollCostCenterAllocations: employeeAllocations || [] };
                                            siteValue += calculateValue(adjustedPayroll, parsedExpr, dim, allocationPercent) * daysBeforeNewSite / totalDaysInPayPeriod;
                                        }
                                        // If this site is the new site
                                        if (normalize(p.siteName) === siteName) {
                                            const adjustedPayroll = { ...p, payrollCostCenterAllocations: employeeAllocations || [] };
                                            siteValue += calculateValue(adjustedPayroll, parsedExpr, dim, allocationPercent) * daysAfterNewSite / totalDaysInPayPeriod;
                                        }
                                    });
                                }
                                if (siteValue > 0) {
                                    const employeeAllocations = payrollRun.payrollRunCostCenterAllocations[p.employeeId];
                                    const costCenterAllocation = employeeAllocations ? employeeAllocations.find(
                                        a => normalize(a.costCenterCode) === normalize(costCenter.code)
                                    ) : null;
                                    const allocationPercent = costCenterAllocation ? costCenterAllocation.allocationPercentage : 0;
                                    employees.push({
                                        employeeId: p.employeeId,
                                        fullName: p.fullName,
                                        orgID: p.orgID,
                                        value: siteValue,
                                        allocationPercent: allocationPercent
                                    });
                                }
                                value += siteValue;
                            });

                            return {
                                name: dim.value,
                                value: value,
                                account: account,
                                employees: employees
                            };
                        })
                    })),
                    get total() {
                        return this.items.reduce((sum, item) =>
                            sum + item.dimensions.reduce((dimSum, dim) => dimSum + dim.value, 0)
                        , 0);
                    }
                };
            });
            // Cost center total is sum of all site totals
            return {
                costCenter,
                siteAllocations,
                get total() {
                    return this.siteAllocations.reduce((sum, siteAlloc) => sum + siteAlloc.total, 0);
                }
            };
        });

        console.log({results})

        // Calculate column totals and grand total (site-level)
        var firstSiteAlloc = results.length > 0 && results[0].siteAllocations && results[0].siteAllocations.length > 0 ? results[0].siteAllocations[0] : undefined;
        const columnTotals = firstSiteAlloc ? firstSiteAlloc.items.flatMap(item =>
            item.dimensions.map((_, dimIdx) =>
                results.reduce((sum, result) =>
                    result.siteAllocations.reduce((siteSum, siteAlloc) =>
                        siteSum + siteAlloc.items.find(i => i.name === item.name).dimensions[dimIdx].value
                    , sum)
                , 0)
            )
        ) : [];
        const grandTotal = results.reduce((sum, result) => sum + result.total, 0);

        setAllocationResults({ results, columnTotals, grandTotal });

        // --- Payables Allocation Logic ---
        // 1. Get payables items
        const payablesItems = costCenterAllocationItems.filter(c => c.category === "Payable");
        // Pre-parse payables expressions
        const payablesParsedExpressions = {};
        payablesItems.forEach(item => {
            try {
                payablesParsedExpressions[item.expression] = new Parser().parse(item.expression);
            } catch (e) {
                console.error('Error parsing payables expression:', item.expression, e);
                payablesParsedExpressions[item.expression] = null;
            }
        });

        // 2. For each payable item, sum across all cost centers, allocate to sites (and dimensions if present)
        const payablesAlloc = payablesItems.map(item => {
            const parsedExpr = payablesParsedExpressions[item.expression];
            // For each site
            const siteAllocations = relevantSites.map(siteObj => {
                const siteCode = siteObj.code;
                const regionCode = siteObj.region && siteObj.region.code ? siteObj.region.code : '';
                const regionShortName = siteObj.region ? siteObj.region.shortName || siteObj.region.name : siteCode;
                const sitePayrolls = sitePayrollsMap[normalize(siteObj.name)] || [];
                // If item has dimensions, allocate per dimension
                if (item.dimentions && item.dimentions.length > 0) {
                    const dimensions = item.dimentions.map(dim => {
                        // Find account using region shortName and key
                        const account = findMatchingRegionAccount(accounts, {key: item.key, regionShortName});
                        // Sum value for all payrolls for this site and dimension
                        let value = 0;
                        sitePayrolls.forEach(p => {
                            if (p[dim.field] === dim.value) {
                                try {
                                    value += safeEvaluate(parsedExpr, p);
                                } catch (e) {}
                            }
                        });
                        return {
                            name: dim.value,
                            value: value,
                            account: account
                        };
                    });
                    return {
                        site: siteCode,
                        regionCode: regionCode,
                        dimensions
                    };
                } else {
                    // No dimensions, just sum for site
                    const account = findMatchingRegionAccount(accounts, {key: item.key, regionShortName});
                    let value = 0;
                    sitePayrolls.forEach(p => {
                        try {
                            value += safeEvaluate(parsedExpr, p);
                        } catch (e) {}
                    });
                    return {
                        site: siteCode,
                        regionCode: regionCode,
                        value: value,
                        account: account
                    };
                }
            });
            return {
                name: item.name,
                siteAllocations
            };
        });
        setPayablesAllocations(payablesAlloc);
        // Set payables grand total for balance check
        const payablesGrand = payablesAlloc.reduce((sum, item) => {
            return sum + item.siteAllocations.reduce((siteSum, siteAlloc) => {
                if (siteAlloc.dimensions && siteAlloc.dimensions.length > 0) {
                    return siteSum + siteAlloc.dimensions.reduce((dSum, dim) => dSum + dim.value, 0);
                } else {
                    return siteSum + (siteAlloc.value || 0);
                }
            }, 0);
        }, 0);
        setPayablesGrandTotal(payablesGrand);
    };

    // Get expense grand total for balance check
    const expenseGrandTotal = allocationResults ? allocationResults.grandTotal : 0;

    return (
        <div>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <IconButton
                                onClick={handleAllocationSheetExpandClick}
                                aria-expanded={allocationSheetExpanded}
                                aria-label="show allocation sheet"
                            >
                                {allocationSheetExpanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">
                                Allocation Sheet
                            </Typography>
                        </Grid>
                    </Grid>
                    <Collapse in={allocationSheetExpanded} timeout="auto" unmountOnExit>
                        <AllocationSheet 
                            filteredPayrolls={filteredPayrolls}
                            costCenters={costCenters}
                            onUpdate={handleAllocationUpdate}
                            payrollRun={payrollRun}
                        />
                    </Collapse>
                </Grid>

                <Grid item>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <IconButton
                                onClick={handleExpandClick}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                {expanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">
                                Cost Center Allocations
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAllocate}
                            >
                                Allocate
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CostCenterAllocationItemsView 
                    costCenterAllocationItems={costCenterAllocationItems}
                    setCostCenterAllocationItems={setCostCenterAllocationItems}
                />
            </Collapse>
            {allocationResults && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '32px 0' }}>
                    {Math.abs(expenseGrandTotal - payablesGrandTotal) < 0.01 ? (
                        <>
                            <CheckCircleIcon style={{ fontSize: 64, color: green[500], marginRight: 16 }} />
                            <span style={{ fontSize: 32, color: green[500], fontWeight: 'bold' }}>Balanced</span>
                        </>
                    ) : (
                        <>
                            <CancelIcon style={{ fontSize: 64, color: red[500], marginRight: 16 }} />
                            <span style={{ fontSize: 32, color: red[500], fontWeight: 'bold' }}>Not Balanced</span>
                        </>
                    )}
                </div>
            )}
            {allocationResults && (<>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                    <PayrollCostCenterAllocationsExcelExport
                        allocationResults={allocationResults}
                        payrollDate={payrollDate}
                        region={region}
                        department={department}
                        site={site}
                        payablesAllocations={payablesAllocations}
                        sites={sites}
                    />
                    <AllocationCSVExport 
                        allocationResults={allocationResults}
                        payrollDate={payrollDate}
                        region={region}
                        department={department}
                        payablesAllocations={payablesAllocations}
                        sites={sites}
                    />
                    <ReactToPrint
                        trigger={() => <Button variant="outlined" color="primary" startIcon={<PrintIcon/>}>Print/PDF</Button>}
                        content={() => componentRef.current}
                        pageStyle="@page { size: A4 landscape;} @media print { body { -webkit-print-color-adjust: exact;} }"
                    />
                </div>
                <div ref={componentRef} style={{marginTop:16}}>
                    <ReportHeader logo={logo} payrollRun={payrollRun} title="Cost Center Allocations"/>
                    <AllocationResultsTable {...allocationResults} />
                    {/* Payables Allocation Table below Expense Allocation */}
                    {payablesAllocations && payablesAllocations.length > 0 && (
                        <div style={{marginTop: 32}}>
                            <Typography variant="h6" style={{marginBottom: 8}}>Payables Allocation</Typography>
                            <PayablesAllocationTable payablesAllocations={payablesAllocations} sites={sites} />
                        </div>
                    )}
                </div>
            </>)}
        </div>
    );
};

export default PayrollCostCenterAllocations;